import { render } from "./footer-page.vue?vue&type=template&id=4b19d83e&scoped=true"
import script from "./footer-page.vue?vue&type=script&lang=js"
export * from "./footer-page.vue?vue&type=script&lang=js"

import "./footer-page.vue?vue&type=style&index=0&id=4b19d83e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b19d83e"]])

export default __exports__